export default {
    getFromFile: async (file: File)=> {
        return new Promise(resolve => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onloadend = () => resolve(reader.result)
        })
    },
    getFromURL: async (url: string) => {
        const data = await fetch(url)
        const blob = await data.blob()
        return new Promise(resolve => {
            const reader = new FileReader()
            reader.readAsDataURL(blob)
            reader.onloadend = () => resolve(reader.result)
        })
    }
}